import React from 'react';

function HorizontalBarWithPlusOnTop({ transform }: { transform?: string }) {
    return (
        <svg width="16" height="16" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg" transform={transform}>
            <rect x="10" y="110" width="140" height="40" stroke="black" strokeWidth="8" fill="none" />
            <rect x="75" y="15" width="10" height="75" fill="black" />
            <rect x="40" y="45" width="80" height="10" fill="black" />
        </svg>
    );
}

function HorizontalBarWitCross({ transform }: { transform?: string }) {
    return (
        <svg width="16" height="16" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg" transform={transform}>
            <rect x="10" y="60" width="140" height="40" stroke="currentColor" strokeWidth="8" fill="none" />
            <line x1="0" y1="0" x2="160" y2="160" stroke="black" strokeWidth="8" />
            <line x1="160" y1="0" x2="0" y2="160" stroke="black" strokeWidth="8" />
        </svg>
    );
}

export function MarkdownEditorRemoveRowIcon() {
    return <HorizontalBarWitCross />;
}

export function MarkdownEditorRemoveColumnIcon() {
    return <HorizontalBarWitCross transform="rotate(90)" />;
}

export function MarkdownEditorAddRowBeforeIcon() {
    return <HorizontalBarWithPlusOnTop />;
}

export function MarkdownEditorAddRowAfterIcon() {
    return <HorizontalBarWithPlusOnTop transform="rotate(180)" />;
}

export function MarkdownEditorAddColumnBeforeIcon() {
    return <HorizontalBarWithPlusOnTop transform="rotate(90)" />;
}

export function MarkdownEditorAddColumnAfterIcon() {
    return <HorizontalBarWithPlusOnTop transform="rotate(-90)" />;
}

export function MarkdownEditorAddTableIcon() {
    return <i className={`fa fa-table`}></i>;
}

export function MarkdownEditorRemoveTableIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 122.88 102.52"
            xmlSpace="preserve"
        >
            <style type="text/css">{'.st0{fill-rule:evenodd;clip-rule:evenodd;}'}</style>
            <g>
                <path
                    className="st0"
                    d="M5.42,0h112.04c2.98,0,5.42,2.44,5.42,5.42V97.1c0,2.98-2.44,5.42-5.42,5.42H5.42c-2.98,0-5.42-2.44-5.42-5.42V5.42C0,2.44,2.44,0,5.42,0L5.42,0z M8.48,23.58H38.1c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,24.25,7.66,23.58,8.48,23.58L8.48,23.58z M84.78,82.35h29.63c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76C83.29,83.02,83.96,82.35,84.78,82.35L84.78,82.35z M46.8,82.35h29.28c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76C45.31,83.02,45.98,82.35,46.8,82.35L46.8,82.35z M8.48,82.35H38.1c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,83.02,7.66,82.35,8.48,82.35L8.48,82.35z M84.78,62.76h29.63c0.82,0,1.48,0.67,1.48,1.48V74c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76C83.29,63.43,83.96,62.76,84.78,62.76L84.78,62.76z M46.8,62.76h29.28c0.82,0,1.48,0.67,1.48,1.48V74c0,0.81-0.67,1.48-1.48,1.48H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76C45.31,63.43,45.98,62.76,46.8,62.76L46.8,62.76z M8.48,62.76H38.1c0.82,0,1.48,0.67,1.48,1.48V74c0,0.81-0.67,1.48-1.48,1.48H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,63.43,7.66,62.76,8.48,62.76L8.48,62.76z M84.78,43.17h29.63c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76C83.29,43.84,83.96,43.17,84.78,43.17L84.78,43.17z M46.8,43.17h29.28c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76C45.31,43.84,45.98,43.17,46.8,43.17L46.8,43.17z M8.48,43.17H38.1c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H8.48c-0.81,0-1.48-0.67-1.48-1.48v-9.76C6.99,43.84,7.66,43.17,8.48,43.17L8.48,43.17z M84.78,23.58h29.63c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H84.78c-0.81,0-1.48-0.67-1.48-1.48v-9.76C83.29,24.25,83.96,23.58,84.78,23.58L84.78,23.58z M46.8,23.58h29.28c0.82,0,1.48,0.67,1.48,1.48v9.76c0,0.81-0.67,1.48-1.48,1.48H46.8c-0.81,0-1.48-0.67-1.48-1.48v-9.76C45.31,24.25,45.98,23.58,46.8,23.58L46.8,23.58z"
                />
                <line x1="0" y1="0" x2="122.88" y2="102.52" stroke="black" strokeWidth="8" />
                <line x1="122.88" y1="0" x2="0" y2="102.52" stroke="black" strokeWidth="8" />
            </g>
        </svg>
    );
}
